<template>
  <div class="visual">
    <div ref="bgDiv" class="bg" :style="{minHeight: bgHeight}"></div>
    <div ref="matchDiv" class="match" :style="{minHeight: matchHeight}"></div>
    <div ref="swiperDiv" class="swiper" :class="{slideHeight : slideHeight}">
      <swiper ref="visualSwiper" :options="swiperOption">
        <swiper-slide
          v-for="(item, index) in list"
          :key="index"
          class="slide">
          <div class="mobile" v-if="item.subject">
            <div class="tag" v-if="item.category">{{ item.category }}</div>
            <div class="title">{{ item.subject }}</div>
          </div>
          <!--<div class="slideInner" :style="item.slide_img && {backgroundImage: `url('${item.slide_img}')`}">-->
          <div class="slideInner">
            <a :href="item.link_url || '#'" class="slideLink">
              <img :src="item.slide_img" alt="img" @load="onImageLoad" :class="{'img-mt': !item.subject}"/>
              <div class="container pc">
                <div class="tag" v-if="item.category">{{ item.category }}</div>
                <div class="title">{{ item.subject }}</div>
                <div class="desc">{{ item.content }}</div>
              </div>
            </a>
          </div>
          <div class="mobile desc" v-if="item.content">{{ item.content }}</div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import {isEmpty} from '@/lib';
// import http from '@/api/index'

export default {
  name: 'MainVisual',
  components: {
    Swiper,
    SwiperSlide
  },
  created() {
    this.init();
  },
  mounted() {
    window.addEventListener('resize', this.adjustDivHeight);
    /*this.$nextTick(() => {
      this.adjustDivHeight();
    });*/
  },
  data() {
    return{
      bgHeight: '',
      matchHeight: '',
      slideHeight: false,
      divTop: 0,
      swiperOption: {
        slidesPerView: 1,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction',
          clickable: true,
        },
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      swiperPause: false,
      list: [],
      imagesLoaded: 0 // 로드된 이미지 수
    }
  },
  methods: {
    async init () {
      const swiper = this.$refs.visualSwiper;
      if (swiper) {
        swiper.$swiper.activeIndex = 1;
      }

      const {data} = await this.$http.get('/main/slide');
      if (data.success) {
        this.list = data.data;

        this.list.map((item) => {
          // 임시 이미지 경로 고정
          item.slide_img = 'https://www.dragons.co.kr/' + item.slide_img;
          item.link_target = '_self';
          if (item.link_type === 'N') {
            item.link_target = '_blank';
          }

          // 테스트용
          /*item.subject = '팬들과 함께한 행복한 "오픈트레이닝데이" 성료';
          item.category = 'NEWS';*/

          if (!isEmpty(item.subject)) {
            this.slideHeight = true;
          }
        });
      }
    },
    onImageLoad() { // event
      this.imagesLoaded++;

      // 이미지 높이에 따라 적용
      /*const imageHeight = event.target.offsetHeight;
      if (imageHeight > 300) {
        const swiperDiv = this.$refs.matchDiv;
        if (swiperDiv && !swiperDiv.classList.contains('imgHeight')) {
          swiperDiv.classList.add('imgHeight');
        }
      }*/

      // 각 이미지가 로드될 때마다 높이 조정
      this.adjustDivHeight();
    },
    adjustDivHeight() {
      const divS = this.$refs.swiperDiv;

      if (!divS || divS.offsetHeight === 0) {
        return;
      }

      const parentDiv = document.querySelector('.swiper');
      const childDiv = parentDiv.querySelector('.swiper-container');
      const childDivHeight = childDiv.offsetHeight;
      const windowWidth = window.innerWidth;
      let availableHeight = (childDivHeight / 2);

      if (windowWidth === 1097) {
        availableHeight = availableHeight + 150;
      }

      let availableBgHeight = availableHeight + 80;
      let availableMatchHeight = availableHeight;

      if (500 <= windowWidth < 1100) {
        availableMatchHeight = availableMatchHeight + 20;
      }

      this.bgHeight = `${availableBgHeight}px`;
      this.matchHeight = `${availableMatchHeight}px`;

      /*console.log('전체 : '+windowWidth+' | 슬라이드 높이 : '+childDivHeight);
      console.log('bgHeight : '+availableHeight+' | matchHeight : '+availableMatchHeight);
      console.log(parentDiv.offsetHeight);*/
    }
  }
}
</script>

<style>
/*.visual .swiper .slideInner img {
  height: 284px; !* 320px; *!
  object-fit: cover;
  width: 100%;
}

@media (max-width: 1099px) {
  .visual .swiper .slideInner img {
    height: 100%;
    object-fit: cover;
    width: 100%;
  }
}*/

@media (min-width: 1100px) {
  .visual .swiper .slideInner img {
    height: 284px;
    object-fit: cover;
    width: 100%;
  }
}
</style>
